module.exports = {
  title: '申诉管理',
  route: {
    path: '/admin-order-manage',
    children: {
      path: 'appeal-manage',
    },
  },
};
